var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"brand-style-2"},_vm._l((_vm.brandImages),function(brand,i){return _c('li',{key:i},[_c('a',{attrs:{"href":brand.url}},[_c('img',{staticStyle:{"max-width":"100%","height":"auto","max-height":"64px"},attrs:{"src":brand.src,"alt":"Logo Images"}})])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }